import { render, staticRenderFns } from "./PortfolioSkill.vue?vue&type=template&id=515c7307&scoped=true&"
import script from "./PortfolioSkill.vue?vue&type=script&lang=js&"
export * from "./PortfolioSkill.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioSkill.vue?vue&type=style&index=0&id=515c7307&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c7307",
  null
  
)

export default component.exports